import { Container } from "@mui/material";
import BazarImage from "components/BazarImage";
import CategorySectionHeader from "components/CategorySectionHeader";
import ShopLayout1 from "components/layouts/ShopLayout1";
import Navbar from "components/navbar/Navbar";
import { H4 } from "components/Typography";
import React from "react";

const HowToOrder = () => {
  return (
    <ShopLayout1 title="How To Order" navbar={<Navbar />}>
      <Container maxWidth="lg" sx={{ p: 2 }}>
        <CategorySectionHeader title="How to Order" />
        <BazarImage
          alt="contact-us"
          src={"/assets/images/banners/how-to-order.png"}
          sx={{ width: "100%", mt: 2 }}
        />
        <H4 mt={5}>Facebook Page:</H4>
        <ol>
          <li>Message us through facebook.com/PC Worth/</li>
          <li>Place your order/quotation.</li>
          <li>Our sales agent will confirm the availability of the item/s.</li>
          <li>
            Once the quotation is final, please verify/double check it with our
            sales agent.
          </li>
          <li>
            To confirm your order, kindly read and agree to our Terms and
            Conditions.
          </li>
          <li>Please fill-up the following:</li>
        </ol>
        <ul style={{ listStyle: "disc", marginLeft: "4rem" }}>
          <li>NAME:</li>
          <li>CONTACT NO:</li>
          <li>HOME ADDRESS:</li>
          <li>DELIVERY OR PICK UP:</li>
          <li>
            MODE OF PAYMENT (Gcash, Bank Transfer, Paymaya, Cash and COD
            (CONSIGNED RIDER ONLY FOR THOSE WHO HAVE A 20% DOWNPAYMENT)):
          </li>
          <li>AGREED TERMS AND CONDITIONS (YES/NO):</li>
        </ul>
        <H4 mt={3}>E-commerce Website:</H4>
        <ol>
          <li>Add item to your cart.</li>
          <li>
            Click on the Cart icon in the upper right corner to view your cart.
          </li>
          <li>Click on the Checkout button</li>
          <li>Enter Billing and Shipping details.</li>
          <li>Select a payment option.</li>
          <li>Click on Confirm Order Button.</li>
        </ol>
        <H4 mt={3}>Important Note:</H4>
        <ul
          style={{
            listStyle: "disc",
            marginLeft: "3rem",
            marginBottom: "5rem",
          }}
        >
          <li>Please transact/message directly to our official page only.</li>
          <li>We require at least 20% down payment.</li>
          <li>
            Cut off periods is until 2:30 p.m. Confirmed orders beyond 2:30 p.m
            will be considered as next day pick up/delivery.
          </li>
          <li>
            Delivery rate is back-to-back (Lalamove rates) with our consigned
            rider.
          </li>
          <li>
            For fully paid transaction, you have the option to book you own
            courier or keep up with our consigned rider.
          </li>
        </ul>
      </Container>
    </ShopLayout1>
  );
};

export default HowToOrder;
